import { render } from "./ReusableCompaniesTable.vue?vue&type=template&id=1d2431a3"
import script from "./ReusableCompaniesTable.vue?vue&type=script&lang=js"
export * from "./ReusableCompaniesTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__